/*  ========================================================================
    # Scripts - Header Meta Menu
    ========================================================================  */

/**
 * Script that handles interactive functionality of the header meta menu
 */

const HeaderMetaMenu = {
  cfg: {
    languageSwitcherButton: document.querySelector('.c-header-meta-menu__language-switcher-button'),
    languageSwitcher: document.querySelector('.c-header-meta-menu__language-switcher')
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.languageSwitcherButton && this.cfg.languageSwitcher) {
      this.cfg.languageSwitcherButton.addEventListener('click', event => {
        event.stopPropagation();
        this.cfg.languageSwitcher.toggleAttribute('data-visible');
      });
      document.addEventListener('click', () => {
        this.cfg.languageSwitcher.removeAttribute('data-visible');
      });
    }
  }
};

export default HeaderMetaMenu;
